import React, { useEffect } from 'react';

import { makeStyles } from '@mui/styles';
import { Box, Button, Container, Toolbar } from '@mui/material';
import classNames from 'classnames';
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import styles from './site-components/site.module.css';
import composerStyles from './composer.module.css';
import DemoPlayer from './site-components/demo/demo-player';

const useStyles = makeStyles(() => ({
  root: {},
}));

const Demo = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const params = useParams();
  const history = useHistory();

  const handleCloseNavMenu = (cat) => {
    history.push(`/demo/${cat}`);
  };

  useEffect(() => {
    // @ts-ignore
    if (!params.category) {
      history.push(`/demo/sports`);
    }
  }, []);

  const categories = ['sports', 'entertainment', 'news', 'extension'];

  return (
    <div className={classes.root}>
      <Container maxWidth="xl" className={classNames(styles.container, styles.section)}>
        <Box className={classNames(styles.mt6)}>
          <Toolbar disableGutters className={classNames(composerStyles.justifyCenter)}>
            <Box className={composerStyles.demoCategories}>
              {categories.map((cat) => (
                <Button
                  key={cat}
                  onClick={() => handleCloseNavMenu(cat)}
                  className={classNames(
                    composerStyles.demoCategoryButtons,
                    composerStyles.secondaryButton,
                    composerStyles.bgWhite,
                    composerStyles.titleCase,
                    { [composerStyles.secondaryButtonActive]: pathname.startsWith(`/demo/${cat}`) }
                  )}
                >
                  {cat}
                </Button>
              ))}
            </Box>
          </Toolbar>

          <Switch>
            <Route path="/demo/:category">
              <DemoPlayer />
            </Route>
          </Switch>
        </Box>
      </Container>
    </div>
  );
};

export default Demo;
